const BonusReducers = (state = [], action) => {
  switch (action.type) {
    case "storeBonus":
      return action.payload;
    default:
      return state;
  }
};
export default BonusReducers;
